/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_None_On_RecordInputs */



/**
* | output |
* | --- |
* | "No NDA on record — the PT role cannot be granted without one." |
*
* @param {Nda_None_On_RecordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_none_on_record = /** @type {((inputs?: Nda_None_On_RecordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_None_On_RecordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun NDA enregistré — le rôle PT ne peut pas être attribué sans NDA.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay NDA registrado — el rol PT no puede otorgarse sin NDA.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum NDA registrado — o papel PT não pode ser concedido sem NDA.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun NDA registrato — il ruolo PT non può essere assegnato senza NDA.")
	return /** @type {LocalizedString} */ ("No NDA on record — the PT role cannot be granted without one.")
});